import React, { cloneElement } from 'react';
import { ArrowRight } from 'lucide-react';
interface ServiceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  accentColor: 'pink' | 'yellow' | 'teal';
  onClick?: () => void;
}
export function ServiceCard({
  title,
  description,
  icon,
  accentColor,
  onClick
}: ServiceCardProps) {
  const accentColors = {
    pink: 'border-wh-pink text-wh-pink group-hover:bg-wh-pink',
    yellow: 'border-wh-yellow text-wh-yellow group-hover:bg-wh-yellow',
    teal: 'border-wh-teal text-wh-teal group-hover:bg-wh-teal'
  };
  const bgColors = {
    pink: 'group-hover:bg-pink-50',
    yellow: 'group-hover:bg-yellow-50',
    teal: 'group-hover:bg-teal-50'
  };
  return <div onClick={onClick} className={`group relative bg-white p-8 rounded-xl shadow-sm border border-gray-100 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 cursor-pointer overflow-hidden`} data-id="element-249">
      {/* Top accent line */}
      <div className={`absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-${accentColor === 'pink' ? 'wh-pink' : accentColor === 'yellow' ? 'wh-yellow' : 'wh-teal'} to-transparent opacity-0 group-hover:opacity-100 transition-opacity`} data-id="element-250" />

      <div className={`w-14 h-14 rounded-lg border-2 flex items-center justify-center mb-6 transition-colors duration-300 ${accentColors[accentColor]} group-hover:text-white`} data-id="element-251">
        {cloneElement(icon as React.ReactElement, {
        className: 'w-7 h-7 transition-colors duration-300'
      })}
      </div>

      <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-gray-900" data-id="element-252">
        {title}
      </h3>

      <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-253">{description}</p>

      <div className={`flex items-center text-sm font-bold ${accentColors[accentColor].split(' ')[1]} transition-colors`} data-id="element-254">
        Learn More{' '}
        <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-255" />
      </div>
    </div>;
}